import React, { FC } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Dispatch, iRootState } from '../../../store';
import Icon from '../../../components_/Icon';
import Tooltip from '../../../components_/Tooltip';
import { AreaModes } from '../../../models/types';
import { Button } from 'antd';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    position: 'absolute',
    top: 10,
    left: 420,
    zIndex: 1000
  }
}));

const mapState = (state: iRootState) => ({
  mode: state.infrastructureMap.mode,
  isGeo: state.infrastructureMap.layers.isGeo,
  mapId: state.infrastructureMap.map.id
});

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    setLayers: d.infrastructureMap.setLayers
  };
};

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

type IProps = connectedProps;

const LayersControl: FC<IProps> = ({ setLayers, isGeo, mode, mapId }) => {
  const classes = useStyles();
  const isAllPlans = mapId === 'all';

  const handleClick = () => () => {
    setLayers({ isGeo: !isGeo });
  };

  return (
    <Grid className={classes.root}>
      <Tooltip size="l" label={isGeo ? 'Свернуть план' : 'Развернуть план'}>
        <Button
          icon={isGeo ? <Icon name={'compressRight'} size="m" /> : <Icon name={'scale'} size="m" />}
          disabled={mode !== AreaModes.Default || isAllPlans}
          key={'isGeo'}
          size={'large'}
          onClick={handleClick()}
        />
      </Tooltip>
    </Grid>
  );
};

const withConnect = connect(mapState, mapDispatch);

export default withConnect(LayersControl);
